module.exports = "<p>\n  categoria works!\n</p>\n"